import React, { useState, useEffect } from 'react';
import {
  Grid,
  TableContainer,
  Typography,
  Modal,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  TableBody,
} from '@mui/material';
import moment from 'moment';

export default function PackageDetailsModal({
  isOpen,
  handleClose,
  repairOrder,
  currentPackage,
}) {
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    let currentEntries = [];

    repairOrder.entries.forEach(entry => {
      if (
        currentPackage.contents &&
        currentPackage.contents.includes(entry.id)
      ) {
        currentEntries.push(entry);
      }
    });

    setEntries(currentEntries);
  }, [currentPackage, repairOrder]);

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Grid
        container
        spacing={2}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 'auto',
          bgcolor: 'var(--dust-white)',
          p: 4,
          maxHeight: '80vh',
          overflowY: 'auto',
        }}
      
      >
        <Grid size={12}>
          <Typography
            id='modal-modal-title'
            sx={{ fontFamily: 'BrightstarSans-Regular', fontSize: '25px' }}
          >
            Contents of Package
          </Typography>
        </Grid>
        <Grid size={12}>
          {entries && entries.length > 0 && (
            <TableContainer
              component={Paper}
              sx={{
                    maxWidth: '1200px',
                    margin: '0 auto',
                    maxHeight: '50vh',
              }}
            >
              <Table
                sx={{
                  minWidth: 400,
                  '& .MuiTableCell-root': {
                    padding: '8px 12px',
                    fontSize: '14px',
                  },
                }}
                aria-label='additional entries table'
              >
                <TableHead>
                  <TableRow sx={{ backgroundColor: 'var(--reach-blue)' }}>
                    <TableCell
                      sx={{
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        padding: '8px 12px',
                        fontSize: '14px',
                      }}
                    >
                      #
                    </TableCell>
                    <TableCell
                      sx={{
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        padding: '8px 12px',
                        fontSize: '14px',
                      }}
                    >
                      Status
                    </TableCell>
                    <TableCell
                      sx={{
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        padding: '8px 12px',
                        fontSize: '14px',
                      }}
                    >
                      Product
                    </TableCell>
                    <TableCell
                      sx={{
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        padding: '8px 12px',
                        fontSize: '14px',
                      }}
                    >
                      Item Number
                    </TableCell>
                    <TableCell
                      sx={{
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        padding: '8px 12px',
                        fontSize: '14px',
                      }}
                    >
                      Serial Number
                    </TableCell>
                    <TableCell
                      sx={{
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        padding: '8px 12px',
                        fontSize: '14px',
                      }}
                    >
                      Total Work Time (min)
                    </TableCell>
                    <TableCell
                      sx={{
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        padding: '8px 12px',
                        fontSize: '14px',
                      }}
                    >
                      Start Date
                    </TableCell>
                    <TableCell
                      sx={{
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        padding: '8px 12px',
                        fontSize: '14px',
                      }}
                    >
                      Completion Date
                    </TableCell>
                    <TableCell
                      sx={{
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        padding: '8px 12px',
                        fontSize: '14px',
                      }}
                    >
                      Parts Used
                    </TableCell>
                    <TableCell
                      sx={{
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        padding: '8px 12px',
                        fontSize: '14px',
                      }}
                    >
                      Failure Mode
                    </TableCell>
                    <TableCell
                      sx={{
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        padding: '8px 12px',
                        fontSize: '14px',
                      }}
                    >
                      Asset Tag
                    </TableCell>
                    <TableCell
                      sx={{
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        padding: '8px 12px',
                        fontSize: '14px',
                      }}
                    >
                      Solution
                    </TableCell>
                    <TableCell
                      sx={{
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        padding: '8px 12px',
                        fontSize: '14px',
                      }}
                    >
                      OEM Vendor
                    </TableCell>
                    <TableCell
                      sx={{
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        padding: '8px 12px',
                        fontSize: '14px',
                      }}
                    >
                      Return Date
                    </TableCell>
                    <TableCell
                      sx={{
                        color: 'white',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        padding: '8px 12px',
                        fontSize: '14px',
                      }}
                    >
                      Comments
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {entries.map((entry, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        '&:nth-of-type(odd)': {
                          backgroundColor: '#ffffff',
                        },
                        '&:nth-of-type(even)': {
                          backgroundColor: '#f5f5f5',
                        },
                      }}
                    >
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          padding: '8px 12px',
                          fontSize: '14px',
                        }}
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          padding: '8px 12px',
                          fontSize: '14px',
                        }}
                      >
                        {entry.status || 'N/A'}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          padding: '8px 12px',
                          fontSize: '14px',
                        }}
                      >
                        {entry.product || 'N/A'}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          padding: '8px 12px',
                          fontSize: '14px',
                        }}
                      >
                        {entry.itemNumber || 'N/A'}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          padding: '8px 12px',
                          fontSize: '14px',
                        }}
                      >
                        {entry.serialNumber || 'N/A'}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          padding: '8px 12px',
                          fontSize: '14px',
                        }}
                      >
                        {entry.totalWorkTime || 'N/A'}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          padding: '8px 12px',
                          fontSize: '14px',
                        }}
                      >
                        {entry.startDate
                          ? moment(entry.startDate).format('MM/DD/YYYY')
                          : 'N/A'}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          padding: '8px 12px',
                          fontSize: '14px',
                        }}
                      >
                        {entry.completionDate
                          ? moment(entry.completionDate).format('MM/DD/YYYY')
                          : 'N/A'}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          padding: '8px 12px',
                          fontSize: '14px',
                        }}
                      >
                        {entry.partsUsed.length > 0
                          ? entry.partsUsed.join(', ')
                          : 'N/A'}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          padding: '8px 12px',
                          fontSize: '14px',
                        }}
                      >
                        {entry.failureMode || 'N/A'}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          padding: '8px 12px',
                          fontSize: '14px',
                        }}
                      >
                        {entry.assetTag || 'N/A'}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          padding: '8px 12px',
                          fontSize: '14px',
                        }}
                      >
                        {entry.solution.length > 0
                          ? entry.solution.join(', ')
                          : 'N/A'}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          padding: '8px 12px',
                          fontSize: '14px',
                        }}
                      >
                        {entry.oemVendor || 'N/A'}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          padding: '8px 12px',
                          fontSize: '14px',
                        }}
                      >
                        {entry.returnDate
                          ? moment(entry.returnDate).format('MM/DD/YYYY')
                          : 'N/A'}
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          padding: '8px 12px',
                          fontSize: '14px',
                        }}
                      >
                        {entry.comments || 'N/A'}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Grid>
        <Grid
          size={12}
          sx={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <Button
            variant='contained'
            sx={{ marginRight: '10px', backgroundColor: 'var(--arcturus-red)' }}
            onClick={handleClose}
          >
            Close
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
}
